module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Leukerbad-80aef55546e218ce2fbfe4198e833d7f.png";